<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="collapsible-content-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header">
                        <h2
                            class="title"
                            v-test:title
                        >
                            {{ title }}
                        </h2>
                        <b-row v-if="intro">
                            <b-col
                                md="8"
                                offset-md="2"
                            >
                                <markdown-content
                                    class="intro"
                                    :content="intro"
                                    v-test:intro
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col xl="10" offset-xl="1">
                            <info-collapse
                                :title="collapseTitle"
                                :id="collapseId"
                                :centered="centered"
                            >
                                <markdown-content
                                    :content="collapseContent"
                                    v-test:collapseContent
                                />
                            </info-collapse>
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import InfoCollapse from '../../molecules/InfoCollapse/InfoCollapse';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import uniqueId from 'lodash/uniqueId';

    export default {
        name: 'collapsible-content-section',

        components: { InfoCollapse, MarkdownContent },

        props: {
            title: {
                type: String,
                required: true,
            },

            intro: {
                type: String,
                default: '',
            },

            collapseTitle: {
                type: String,
                required: true,
            },

            collapseContent: {
                type: String,
                required: true,
            },

            centered: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                collapseId: `collapse-${ uniqueId() }`,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .collapsible-content-section {
        padding: 34px 0;
    }

    .header {
        text-align: center;
        margin-bottom: 11px;
    }

    .title {
        font-size: rem(32px);
        line-height: rem(36px);
        font-weight: 700;

        @include media-breakpoint-up(lg) {
            font-size: rem(40px);
            line-height: rem(44px);
        }
    }

    .intro {
        font-size: rem(20px);
    }

    .info-collapse {
        margin-bottom: 15px;

        &.centered {
            .markdown-content {
                text-align: center;
            }
        }

        .markdown-content {
            font-size: rem(16px);
        }
    }

    .markdown-content ::v-deep {
        h3 {
            font-size: rem(20px);
        }
    }
</style>
